export function getFilteredProducts(products, status) {
    console.log("Products to be filtered are: ", products?.length);
    const filteredProducts = products?.filter((product) => { return product?.status?.toLowerCase() === status?.toLowerCase() });
    console.log("filtered draft Products are: ", filteredProducts?.length);
    return filteredProducts;
};

